import React, { PureComponent } from 'react';
import { Select } from 'antd';
import { api } from '$app/api';
import { BOOKING_STATUS } from '$app/apps/bookings/containers/BookingPage/constants';

const Option = Select.Option;

class CaseManagerSelector extends PureComponent {
  state = {
    caseManagers: null,
  };

  async componentDidMount() {
    try {
      const { data } = await api.get('/case-managers');
      this.setState({ caseManagers: data });
    } catch (error) {
      this.setState({ caseManagers: [] });
    }
  }

  handleChange = (caseManagerId) => {
    this.props.onCaseManagerChange({ caseManagerId });
  };

  render() {
    let { caseManagers } = this.state;
    const { bookingStatus, caseManagerId } = this.props;
    const disableSelectCMBtn = [BOOKING_STATUS.CANCELLED, BOOKING_STATUS.CLOSED].includes(bookingStatus);
    const placeholderText = 'Assign booking to';

    if (!caseManagers) return null;

    if (caseManagerId) {
      caseManagers = caseManagers.slice();
      caseManagers.unshift({
        userId: 'unassign',
        givenName: 'Unassign',
      });
    }

    return (
      <Select
        value={caseManagerId || placeholderText}
        placeholder={placeholderText}
        style={{ width: 200 }}
        onChange={this.handleChange}
        disabled={disableSelectCMBtn}
      >
        {caseManagers.map((cm) => (
          <Option key={cm.userId} value={cm.userId}>
            {cm.givenName} {cm.familyName}
          </Option>
        ))}
      </Select>
    );
  }
}

export default CaseManagerSelector;
